// @copyright  2006 - 2023 West Indies Software Engineering Company Limited. All rights reserved.

export default {
    '$dir': 'ltr',

    'payroll-batch-payment.page.title': 'Payroll Payments',
    'payroll-batch-payment.page.create.title': 'New Payment',
    'payroll-batch-payment.page.view.title': 'View Payroll Payment',
    'payroll-batch-payment.page.title.redo': 'Redo Payment',

    'payroll-batch-payment.button.cancel': 'Cancel',
    'payroll-batch-payment.button.create': 'Record Payment',
    'payroll-batch-payment.button.new': 'Record Payment',
    'payroll-batch-payment.button.payments': 'Payment History',
    'payroll-batch-payment.button.void': 'Void Payment',
    'payroll-batch-payment.button.refund': 'Refund Payment',
    'payroll-batch-payment.button.rollback': 'Rollback Payment',
    'payroll-batch-payment.button.redo': 'Redo',

    'payroll-batch-payment.message.overpayment': 'Paying more than expected.',

    'payroll-batch-payment.link.nothing-created': 'No payments made as yet',
    'payroll-batch-payment.link.payroll_batch_payments': ' Return to Payroll Batch Payments',
    'payroll-batch-payment.link.retry': 'Click here to retry',

    'payroll-batch-payment.label.payroll_batch_name': 'Payroll Batch',
    'payroll-batch-payment.label.item': 'Item',
    'payroll-batch-payment.label.balance': 'Balance',
    'payroll-batch-payment.label.amount': 'Amount',
    'payroll-batch-payment.label.total': 'Total',
    'payroll-batch-payment.label.transaction_type': 'Record Transaction as',
    'payroll-batch-payment.label.batch_transaction': 'A single bank transaction',
    'payroll-batch-payment.label.individual_transaction': 'One bank transaction per employee',

    'payroll-batch-payment.label.transaction_date': 'Transaction Date',
    'payroll-batch-payment.label.bank_general_ledger_account_name': 'Bank Account',
    'payroll-batch-payment.label.payment_method': 'Payment Method',
    'payroll-batch-payment.label.reference_code': 'Reference Code',
    'payroll-batch-payment.label.memo': 'Memo',
    'payroll-batch-payment.label.currency_name': 'Currency',
    'payroll-batch-payment.label.currency_amount_in_cents': 'Amount',
    'payroll-batch-payment.label.cancelled_on': 'Cancelled On',

    'payroll-batch-payment.label.reason_for_void': 'Reason for voiding',
    'payroll-batch-payment.label.rollback_reason': 'Reason for rollback',
    'payroll-batch-payment.label.refund_reason': 'Reason for refund',

    'payroll-batch-payment.sort.field_label': 'Field',
    'payroll-batch-payment.sort.direction_label': 'Direction',
    'payroll-batch-payment.sort.direction_ascending': 'Ascending',
    'payroll-batch-payment.sort.direction_descending': 'Descending',

    'payroll-batch-payment.modal.title.payroll_batch_payment_void': 'Void Payment',
    'payroll-batch-payment.modal.title.payroll_batch_payment_refund': 'Refund Payment',
    'payroll-batch-payment.modal.title.payroll_batch_payment_rollback': 'Rollback Payment',

    'payroll-batch-payment.success.message.payroll_batch_payment_voided': 'Your payroll payment has been voided',
    'payroll-batch-payment.success.message.payroll_batch_payment_refunded': 'Your payroll payment has been refunded',
    'payroll-batch-payment.success.message.payroll_batch_payment_rolled_back': 'Your payroll payment has been rolled back',
    'payroll-batch-payment.success.message.payroll_batch_payment_redone': 'Your payroll payment has been redone',
    'payroll-batch-payment.success.message.payroll_batch_payment_created': 'Your payroll batch payment has been created',

    'payroll-batch-payment.modal.message.cannot_rollback': 'This payment cannot be rolled back.',

    'payroll-batch-payment.error.message.error_loading_page': 'Sorry, there was an error loading payroll batch payment.| Sorry, there was an error loading payroll batch payments.',
};
